import React from "react";
import { makeStyles } from "@material-ui/core";
import { ITheme, colours } from "../constants/theme";
import backArrow from "../assets/icons/backArrow.svg";

export default function BackButton({ onClick, style }: { onClick: () => void, style?: React.CSSProperties }) {
  const classes = useStyles();
  return (
    <img
      src={backArrow}
      alt="back arrow icon"
      draggable={false}
      className={classes.backImg}
      onClick={onClick}
      style={style}
    />
  )
}

const useStyles = makeStyles((theme: ITheme) => ({
  backImg: {
    width: 40,
    height: 40,
    borderRadius: 20,
    color: theme.palette.primary.main,
    backgroundColor: colours.highEmphasis,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: colours.highEmpasis008,
    },
    "&:active": {
      backgroundColor: colours.highEmpasis24,
    },
  },
}));